import { render } from "./StockLedger.vue?vue&type=template&id=42b8d678&scoped=true"
import script from "./StockLedger.vue?vue&type=script&lang=js"
export * from "./StockLedger.vue?vue&type=script&lang=js"

import "./StockLedger.vue?vue&type=style&index=0&id=42b8d678&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b8d678"]])

export default __exports__